/**
* DevExpress Analytics (core\internal\_hoverInfo.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HoverInfo = (function () {
    function HoverInfo() {
        this._x = 0;
        this._y = 0;
        this.isOver = false;
    }
    Object.defineProperty(HoverInfo.prototype, "x", {
        get: function () {
            return this._x;
        },
        set: function (newX) {
            this._x = newX;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HoverInfo.prototype, "y", {
        get: function () {
            return this._y;
        },
        set: function (newY) {
            this._y = newY;
        },
        enumerable: true,
        configurable: true
    });
    return HoverInfo;
}());
exports.HoverInfo = HoverInfo;
